export default "__VITE_ASSET__0f7d5fac__"